import xlsx from 'xlsx';
import { TFunction } from 'react-i18next';

export const csvExt = 'CSV';
export const xlsxExt = 'XLSX';

export class ConsentFileReader extends FileReader {
  public resolve(file: File, translator: TFunction<'fileManagement'>): Promise<string[]> {
    return new Promise<string[]>((resolve, reject) => {
      const fileNameInUpperCase = file.name.toUpperCase();
      if (!fileNameInUpperCase.endsWith(csvExt) && !fileNameInUpperCase.endsWith(xlsxExt)) {
        reject(new Error(translator('upload.error.invalidFileFormat')));
      }

      this.onerror = reject;

      if (fileNameInUpperCase.endsWith(csvExt)) {
        this.onload = () => {
          try {
            this.resultAsArray(this.result as string, resolve, reject, translator);
          } catch (e) {
            reject(e);
          }
        };

        this.readAsText(file);
        return;
      }

      this.onload = () => {
        try {
          const workbook = xlsx.read(this.result, { type: 'binary' });
          const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
          const data = xlsx.utils.sheet_to_csv(firstSheet);

          this.resultAsArray(data, resolve, reject, translator);
        } catch (e) {
          reject(e);
        }
      };
      this.readAsBinaryString(file);
    });
  }

  private resultAsArray(result: string, resolve, reject, translator: TFunction<'fileManagement'>): void {
    const dataArray = result.split(/\r?\n/).filter(line => !!line);

    if (dataArray.length < 1) {
      reject(new Error(translator('upload.error.emptyFile')));
    }

    resolve(dataArray);
  }
}
